import { contentFade } from './content-fade.animation';
import { openClose } from './open-close.animations';
import { tableExpand } from './table-expand.animation';
import { tableLoading } from './table-loading.animation';

const animation = {
  contentFade,
  openClose,
  tableExpand,
  tableLoading
};

export default animation;
